import styled from "styled-components";
import React from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css"
import { Link as LinkScroll, animateScroll as scroll } from "react-scroll";

import i18next from "i18next";
const Navbar = ({ t }) => {
  const [currentLng, setCurrentLng] = React.useState(
    localStorage.getItem("i18nextLng")
  );
  function handleLangChange() {
    const next = localStorage.getItem("i18nextLng");
    if (next === "pl") {
      i18next.changeLanguage("en");
      setCurrentLng("en");
    } else {
      i18next.changeLanguage("pl");
      setCurrentLng("pl");
    }
  }

  return (
    <StyledContent className="content">
      <p>Błażej Batko</p>
      <ul>
        <li>
          <LinkScroll
            to="umiejetnosci"
            smooth={true}
            duration={1200}
            href="#umiejetnosci"
          >
            {t("umiejetnosci")}
          </LinkScroll>
        </li>
        <li>
          <LinkScroll
            to="contact"
            smooth={true}
            duration={2000}
            href="#contact"
          >
            {t("kontakt")}
          </LinkScroll>
        </li>
        <li>
          <LinkScroll
            to="portfolio"
            smooth={true}
            duration={1500}
            href="#portfolio"
          >
            {t("projekty")}
          </LinkScroll>
        </li>
        <StyledLi>
        <p> PL</p>
          
          <label>
            
            <Toggle
            icons={{
              checked: null,
              unchecked: null,
            }}
              defaultChecked={currentLng === 'en' ? true : false}
              className="toggle-lng"
              onChange={handleLangChange}
            />
          </label>
          <p> ENG </p>
        </StyledLi>
      </ul>
    </StyledContent>
  );
};
//
export default Navbar;

const StyledLi = styled.div`

p {
  padding: 0 10px !important;
  font-size: 2rem !important;
}

z-index: 20;
display: flex;
align-items: center;
justify-content: center;
text-align: center;

label {
  display: flex;
  border: 1px solid white;
  border-radius: 0;
  box-shadow: 3px 3px 0 #27201e;
}

@media (max-width: 600px) {
    position: absolute;
    top: 2rem;
    right: 1rem;
  
 
}

.react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
  box-shadow: none;
}
.react-toggle-track {
  border-radius: 0;
}
.react-toggle--checked .react-toggle-thumb {
  box-shadow: none;
}
.react-toggle--focus .react-toggle-thumb {
  box-shadow: none;
}
.react-toggle-thumb {
  border-radius: 0;
}
.toggle-lng.react-toggle--checked .react-toggle-track {
 background-color: #483A37;
}
.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: #483A37;
}
.react-toggle-track {
  background-color: #483A37;
}

.react-toggle--checked .react-toggle-thumb {
  
  border: none;
}




`;
const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;

  p {
    font-size: 2rem;
    color: #f8f8f8;
    padding: 0 0 0 2rem;
  }
  ul {
    display: flex;
    list-style: none;
    padding-right: 4rem;
    flex-wrap: wrap;
    gap: 2em;
    align-items: center;
  }
  li {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 2em;
  }

  li > a {
    font-size: 2rem;
    color: #f8f8f8;
    z-index: 21;
    position: relative;
    text-decoration: none;
    cursor: pointer;
  }

  button {
    display: block;
    background: inherit;
    border: none;
    font-family: "Anton", sans-serif;
    color: #f8f8f8;
    z-index: 21;
    position: relative;
    text-decoration: none;
    cursor: pointer;
  }

  @media (max-width: 500px) {
    button {
      position: absolute;
      top: 2rem;
      right: 2rem;
    }
  }
  @media (max-width: 768px) {
    ul {
      display: flex;
      text-align: end;
      padding-left: 2rem;
      align-items: center;
      gap: 2em;
    }

    li {
      font-size: 1.2rem;
    }
  }
`;
